import {request, serviceUrl} from "@/utils/request";

//告警等级策略列表
export function getList(spaceId = null, categoryId = null, deviceId = null, pointId = null) {
  return request({
    url: serviceUrl.deviceService + '/alarm/upgrade/list',
    params: {
      spaceId, categoryId, deviceId, pointId
    }
  })
}

//新增告警等级策略
export function saveUpgrade(params) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/alarm/upgrade/save',
    data: params
  })
}

//编辑告警等级策略
export function editUpgrade(params) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/alarm/upgrade/edit',
    data: params
  })
}

//删除告警等级策略
export function deleteUpgrade(id) {
  return request({
    url: serviceUrl.deviceService + '/alarm/upgrade/delete',
    params: {id}
  })
}
